import { DateRange } from '@mui/x-date-pickers-pro';
import { PickersShortcutsItem, PickersInputLocaleText } from '@mui/x-date-pickers';
import { endOfWeek, startOfWeek, endOfMonth, startOfMonth, addMonths, addWeeks } from 'date-fns';
import { TFunction } from 'i18next';

export const shortcutsItems: Array<PickersShortcutsItem<DateRange<Date>>> = [
  {
    label: 'general.dateTime.today',
    id: 'today_button',
    getValue: () => {
      const today = new Date();
      return [today, today];
    },
  },
  {
    label: 'general.dateTime.thisWeek',
    id: 'this_week_button',
    getValue: () => {
      return [startOfWeek(new Date(), { weekStartsOn: 1 }), new Date()];
    },
  },
  {
    label: 'general.dateTime.previousWeek',
    id: 'previous_week_button',
    getValue: () => {
      const prev = addWeeks(new Date(), -1);
      return [startOfWeek(prev, { weekStartsOn: 1 }), endOfWeek(prev, { weekStartsOn: 1 })];
    },
  },
  {
    label: 'general.dateTime.thisMonth',
    id: 'this_month_button',
    getValue: () => {
      return [startOfMonth(new Date()), new Date()];
    },
  },
  {
    label: 'general.dateTime.previousMonth',
    id: 'previous_month_button',
    getValue: () => {
      const prev = addMonths(new Date(), -1);
      return [startOfMonth(prev), endOfMonth(prev)];
    },
  },
];

export function localeText(t: TFunction<'translation', undefined>): Partial<PickersInputLocaleText> {
  return {
    start: t('general.dateTime.startDate'),
    startTime: t('general.dateTime.startDate'),
    startDate: t('general.dateTime.startDate'),
    end: t('general.dateTime.endDate'),
    endTime: t('general.dateTime.endDate'),
    endDate: t('general.dateTime.endDate'),
    okButtonLabel: t('general.ok'),
    cancelButtonLabel: t('general.close'),
    nextStepButtonLabel: t('general.next'),
  };
}
